// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ToggleButton } from '~/components/widgets';
import { Base, Label, ToggleContainer } from './styles';

type Props = {
    currentValue: boolean,
    handleChange: boolean => void,
    label: $npm$ReactIntl$MessageDescriptor
};
const ActionCheckbox = ({ currentValue, handleChange, label }: Props) => (
    <Base>
        <Label>
            <FormattedMessage {...label} />
        </Label>
        <ToggleContainer>
            <ToggleButton isOn={currentValue} onChange={() => handleChange(!currentValue)} />
        </ToggleContainer>
    </Base>
);
export default ActionCheckbox;



// WEBPACK FOOTER //
// ./src/components/widgets/actions/action-attribute/attribute-types/checkbox/component.js